import React from 'react';
import { Route } from 'react-router';
import { bindPageViewTracking } from 'utils/tracking';
import TranslationProvider from 'client/components/translationProvider';
import CartPageContainer from 'routes/cart/components/CartPageContainer';
import App from './app';

export default (
  <Route component={App}>
    <Route component={TranslationProvider} keys={['app', 'common', 'errors']}>
      <Route path="/" component={CartPageContainer} onEnter={bindPageViewTracking()} />
    </Route>
  </Route>
);
